import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Form } from '@unform/web';
import { Link, useHistory } from "react-router-dom";
import * as Yup from 'yup';
import { toast } from "react-toastify";
import { FaAngleDown } from 'react-icons/fa'

import getValidationErrors from '../../utils/getValidationErrors';

import { useAuth } from '../../hooks/AuthContext'

import logo from '../../assets/image 6.svg'
import userIcon from '../../assets/icons/user_3.png'
import homeIcon from '../../assets/icons/home_3.png'

import api from '../../services/api';

import Input from '../Input';
import { Menu, Burger} from './Sidebar'

import { Container, Popover, ChangePass } from './styles';


const Header = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [toggleForgetPass, setToggleForgetPass] = useState(false);
  const [open, setOpen] = React.useState(false);
  const nodeRef = useRef(null);
  const { signOut, user, type } = useAuth();
  const history = useHistory();
  const buttonRef = useRef(null);
  const formRef = useRef(null);

  const token = localStorage.getItem('@Ocariot:token');

  const handleChangePass = useCallback(async (data) => {
    try {
      formRef.current?.setErrors({});

      const schema = Yup.object().shape({
        oldPassword: Yup.string().required('Senha necessária'),
        newPassword: Yup.string().required('Senha necessária'),
      });

      await schema.validate(data, { abortEarly: false });

      const typeUser = (type === 1) ? "parent" : "admin";

      await api.put(`${typeUser}/${user._id}`, { oldPassword: data.oldPassword, newPassword: data.newPassword }, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });

      toast.success('Senha alterada com sucesso!')

      setToggleForgetPass(false)
      setIsDropdownOpen(false)

    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err)
        formRef.current?.setErrors(errors);

        return;
      }
      toast.error('Usuário ou senha inválidos. Por favor tente novamente');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    const handleDropdown = event => {
      if (buttonRef.current &&
        !buttonRef.current.contains(event.target) &&
        isDropdownOpen
      ) {
        setIsDropdownOpen(!isDropdownOpen);
        setToggleForgetPass(!setToggleForgetPass)
      }
    }

    document.addEventListener('mousedown', handleDropdown);

    return () => document.removeEventListener('mousedown', handleDropdown);
  }, [buttonRef, isDropdownOpen, toggleForgetPass]);


  return (
    <Container ref={buttonRef}>
      <div className="mobile-header" ref={nodeRef}>
        <Burger open={open} setOpen={setOpen} />
        <Menu open={open}/>
      </div>
      <img id="ocariot-logo" src={logo} alt="Ocariot" onClick={() => history.push('dashboard')} />
      <div className="buttons-container">
        <button id="home-button" onClick={() => history.push('dashboard')}>
          <img src={homeIcon} alt="Perfil" />
        </button>
        <button
          ref={buttonRef}
          onClick={() => {
            setIsDropdownOpen(!isDropdownOpen);
            setToggleForgetPass(false);
          }}
        >
          <img src={userIcon} alt="Perfil" />
        </button>
      </div>

      <Popover ref={buttonRef} isFocused={isDropdownOpen} maxHeight={toggleForgetPass}>
        {isDropdownOpen &&
          <>
            <strong>{user.nickname}</strong>

            <ChangePass isFocused={toggleForgetPass}>
              <button className={toggleForgetPass ? "toggle-bnt active" : "toggle-bnt" }onClick={() => setToggleForgetPass(!toggleForgetPass)}>
                <span>Mudar senha</span>
                <FaAngleDown />

              </button>
              {toggleForgetPass && (
                <Form ref={formRef} onSubmit={handleChangePass}>
                  <div className="input-div">
                    <label>Senha atual</label>
                    <Input name="oldPassword" placeholder="Digite sua senha atual" icon={true} issmall="true" />
                  </div>

                  <div className="input-div">
                    <label>Nova senha</label>
                    <Input name="newPassword" placeholder="Digite sua nova senha" icon={true} issmall="true" />
                  </div>

                  <footer>
                    <button className="change-pass-bnt">Salvar</button>
                  </footer>

                </Form>
              )}
            </ChangePass>

            <Link
              to="about"
              onClick={() => {
                setIsDropdownOpen(!isDropdownOpen);
                setToggleForgetPass(false);
              }}>Sobre o sistema</Link>

            <Link
              onClick={
                () => {
                  signOut();
                  toast.info('Até mais!')
                }} to="/">
              Sair
            </Link>
          </>
        }

      </Popover>
    </Container>

  );
}

export default Header;